// Complete list of PyArrow data types (primary names only, no aliases), sorted alphabetically
export const DATA_ELEMENT_TYPES = [
  'binary',
  'binary_view',
  'bool',
  'bool8',
  'date32',
  'date64',
  'decimal128',
  'decimal256',
  'dense_union',
  'dictionary',
  'duration',
  'fixed_shape_tensor',
  'float16',
  'float32',
  'float64',
  'int8',
  'int16',
  'int32',
  'int64',
  'json',
  'large_binary',
  'large_list',
  'large_list_view',
  'large_string',
  'list',
  'list_view',
  'map',
  'month_day_nano_interval',
  'null',
  'opaque',
  'run_end_encoded',
  'sparse_union',
  'string',
  'string_view',
  'struct',
  'time32',
  'time64',
  'timestamp',
  'uint8',
  'uint16',
  'uint32',
  'uint64',
  'union',
  'uuid',
];

// Shorter list used for processing rule input/output types
export const PROCESSING_RULE_TYPES = [
  'any',
  'binary',
  'bool',
  'date32',
  'decimal128',
  'float32',
  'float64',
  'int32',
  'int64',
  'list',
  'map',
  'struct',
  'timestamp',
  'string',
];
